import { render, staticRenderFns } from "./InitPasswordForm.vue?vue&type=template&id=688a41c2&"
import script from "./InitPasswordForm.vue?vue&type=script&lang=js&"
export * from "./InitPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports